import React from 'react';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import EditText from '../crm/shared/field_inputs/text/EditText';
import EditFileMany from '../crm/shared/field_inputs/file/EditFileMany';
import ExlEditEmailDraft from './field_inputs/ExlEditEmailDraft';
import { HandleEmailAllBookings } from './requests/BookingRequests';
import ExlEmailModal from './shared/ExlEmailModal';
import { useTranslation } from 'react-i18next';
import {
    COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_SUBJECT_LABEL,
    COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_MESSAGE_LABEL,
    COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_ATTACHMENTS_LABEL,
    COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_ATTACHMENTS_ADD_LABEL,
    COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_ATTACHMENTS_REMOVE_LABEL,
    COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_SUBJECT_VALIDATION,
    COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_CONTENT_VALIDATION,
    COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_ATTACHMENTS_MAX_SIZE_VALIDATION
} from '../../i18n/keyConstants';


const EmailBookings = ({
    recipients,
    open,
    onClose,
    description,
    submitHandler
}) => {
    const { t } = useTranslation(['courseDetailsHeader']);

    const validateAttachments = (attachments) => {
        const maxAttachmentSize = 19922944; //Equates to 19MB in bytes
        let totalAttachmentSize;

        if (attachments) {
            totalAttachmentSize = attachments.reduce((size, attachment) => size + attachment.size, 0);
        }

        if (totalAttachmentSize > maxAttachmentSize) {
            return t(COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_ATTACHMENTS_MAX_SIZE_VALIDATION);
        }

        return '';
    }

    const formComponents = [
        {
            propName: 'subject',
            label: t(COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_SUBJECT_LABEL),
            validate: (v) => (!v || !v.length ? t(COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_SUBJECT_VALIDATION) : ''),
            component: <EditText />,
        },
        {
            propName: 'emailBody',
            label: t(COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_MESSAGE_LABEL),
            validate: (v) => (!v || !v.length ? t(COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_CONTENT_VALIDATION) : ''),
            component: <ExlEditEmailDraft />
        },
        {
            propName: 'attachments',
            label: t(COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_ATTACHMENTS_LABEL),
            validate: validateAttachments,
            component: <EditFileMany
                addButtonText={t(COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_ATTACHMENTS_ADD_LABEL)}
                removeButtonText={t(COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_ATTACHMENTS_REMOVE_LABEL)}
            />,
        },
    ];

    const handleAdd = async (email) => {
        var result = await HandleEmailAllBookings(email.emailBody, email.subject, recipients, email.attachments);

        return result;
    };

    return (
        <ExlEmailModal
            open={open}
            onClose={onClose}
            description={description}
            defaultFormComponents={formComponents}
            handleAdd={handleAdd}
            onSuccessiveSave={() => submitHandler()}
            isExl
        />
    );
};

export default EmailBookings;
